import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {GapDashboardComponent} from './gap-dashboard/gap-dashboard.component';
import {GapDetailsComponent} from './gap-details/gap-details.component';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../shared/shared.module';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {FormsModule} from '@angular/forms';



@NgModule({
  declarations: [
    GapDashboardComponent,
    GapDetailsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MDBBootstrapModule,
    RouterModule,
    SharedModule,
    LazyLoadImageModule,
  ],
  exports: [
    GapDashboardComponent,
    GapDetailsComponent
  ]
})
export class GapModule { }
